module.exports = __webpack_public_path__ + "img/course_Image_three.7ad1a35f.png";